


































































import {Component, Emit, Prop} from "vue-property-decorator";
import abpbase from "../../lib/abpbase";
import {paginationElement} from "@/api/typeDefined";
import AppConsts, {EMPTY_OBJECT} from "@/lib/appconst";
import ajaxHelperInstance from "@/lib/ajaxhelper";

@Component({
    name: 'KBList', filters: {
        imgUrlFilter(url: string = '') {
            if (url && url.indexOf('http') > -1) {
                return url;
            } else {
                let fileResourceUrl: string = AppConsts.fileResourceUrl;
                return `${fileResourceUrl}${url}`;
            }
        },
        urlDecode(url:string){
          return decodeURIComponent(url);
        }
    }
})
export default class KBList extends abpbase {
    //是否显示
    visible: boolean = false;
    keywords: string;
    docTypeId: string;
    //所有数据
    allRecords: any[] = [];

    //分页
    pagination: paginationElement = {
        ...AppConsts.pagination,
        onShowSizeChange: (pageIndex, size) => {
            this.pagination.current = pageIndex;
            this.pagination.pageSize = size;
            this.fetchRecords();
        },
        onChange: pageIndex => {
            this.pagination.current = pageIndex;
            this.fetchRecords();
        }
    };

    //初始化分页参数
    initPagination() {
        this.pagination = {
            ...AppConsts.pagination,
            onShowSizeChange: (pageIndex, size) => {
                this.pagination.current = pageIndex;
                this.pagination.pageSize = size;
                this.fetchRecords();
            },
            onChange: pageIndex => {
                this.pagination.current = pageIndex;
                this.fetchRecords();
            }
        };
    }

    //获取数据
    fetchRecords() {
        let {current, pageSize} = this.pagination;
        const queryParams = {
            currentPage: current,
            pageSize: pageSize,
            docTypeId: this.docTypeId,
            queryParam: this.keywords
        };

        ajaxHelperInstance.get('web/doc/findList', queryParams, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                this.allRecords = data.data || [];
                this.pagination.total = 0;
                if (data) {
                    let {page} = data;
                    if (page) {
                        this.pagination.total = page.total;
                    }
                }
            }
        });
    }

    //显示（初始化）
    show(docTypeId: string = '', keywords: string = '') {
        //显示
        this.visible = true;
        this.docTypeId = docTypeId;
        this.keywords = keywords;
        this.initPagination();
        this.fetchRecords();
    }

    //显示详情
    handleShowDetail(docId: string) {
        if (docId) {
            this.switchRouting('knowledgeBaseDetail', {
                queryParams: JSON.stringify({
                    docId: docId,
                    keywords: this.keywords,
                    skip: false
                })
            });
        }
    }
}
